import { Modal } from '@ui-components-3/ui'
import WeekDayBar from './WeekDayBar'
import AvailabilityLegend from './AvailabilityLegend'
import { OperatingHoursRange } from 'hooks/operating-hours/types'
import { useTranslation } from 'react-i18next'
import { useOperatingHoursWeekdaySegments } from 'hooks/operating-hours/useOperatingHoursWeekdaySegments'

type OperatingHoursModalProps = {
  onClose: () => void
  operatingHoursRanges: OperatingHoursRange[]
  baseDate?: Date
}

const OperatingHoursModal = ({ onClose, operatingHoursRanges, baseDate }: OperatingHoursModalProps) => {
  const { t } = useTranslation()

  const segments = useOperatingHoursWeekdaySegments(operatingHoursRanges, baseDate)

  return (
    <Modal opened label={t('operatingHours.modal.title')} onClose={onClose} size="l" showHeaderCloseButton>
      <div className="flex flex-col gap-2 sm:gap-3">
        <div className="flex flex-col gap-1">
          <p className="text-lg font-medium text-black">{t('operatingHours.modal.subtitle')}</p>
          <p className="text-sm font-normal italic text-black">{t('operatingHours.modal.smallSubtitle')}</p>
        </div>
        <div className="mt-2 overflow-hidden rounded-lg border border-neutral-300 bg-white">
          <ul className="list-none">
            {segments.map((item) => (
              <WeekDayBar key={item.title} data={item} />
            ))}
          </ul>
          <AvailabilityLegend />
        </div>
        <div className="text-left italic text-black">{t('operatingHours.modal.footer')}</div>
      </div>
    </Modal>
  )
}

export default OperatingHoursModal
